/**
 * CommandHistory - Recent commands dropdown
 */

import React from 'react';
import { Clock, CheckCircle, Send, FileText } from 'lucide-react';
import { Pressable } from '../../common/motionSystem';

// Status icon mapping
const statusIcons = {
  success: CheckCircle,
  sent: Send,
  generated: FileText,
  scheduled: Clock,
};

const statusColors = {
  success: '#10B981',
  sent: '#3B82F6',
  generated: '#F59E0B',
  scheduled: '#8B5CF6',
};

const CommandHistory = ({ commands, onSelect }) => {
  if (!commands || commands.length === 0) return null;

  return (
    <div className="command-bar-section">
      <div className="command-bar-section-title">Recent Commands</div>
      {commands.map((cmd) => {
        const StatusIcon = statusIcons[cmd.status] || CheckCircle;
        const statusColor = statusColors[cmd.status] || '#10B981';

        return (
          <Pressable
            as="div"
            key={cmd.id}
            className="command-bar-suggestion-item"
            onClick={() => onSelect(cmd)}
          >
            <div className="command-bar-suggestion-icon">
              <Clock size={16} />
            </div>
            <div className="command-bar-suggestion-content">
              <div className="command-bar-suggestion-title">{cmd.query}</div>
              <div className="command-bar-suggestion-desc">
                {cmd.resultCount && `${cmd.resultCount} results`}
                {cmd.recipients && `Sent to ${cmd.recipients} recipients`}
                {cmd.status === 'scheduled' && 'Scheduled'}
              </div>
            </div>
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                gap: 6,
              }}
            >
              <StatusIcon size={12} color={statusColor} />
              <span className="command-bar-suggestion-meta">{cmd.timestamp}</span>
            </div>
          </Pressable>
        );
      })}
    </div>
  );
};

export default CommandHistory;
